import { useState } from 'react'

import styled from 'styled-components'

import Badge from '@totallymoney/ui/components/Badge'
import { focusOutlineStyle } from '@totallymoney/ui/styles/focus'
import theme from '@totallymoney/ui/theme'

import BestMatchModal from '@components/BestMatchModal'

const StyledButton = styled.button`
    padding: 0;
    border: 0;

    &:active,
    &:focus {
        ${focusOutlineStyle};
        border-radius: ${theme.radii.borderRadius05};
    }

    &:hover {
        cursor: pointer;
    }
`

const BestMatchBadge = () => {
    const [isModalOpen, setIsModalOpen] = useState(false)

    return (
        <>
            <StyledButton
                onClick={() => setIsModalOpen(true)}
                aria-label="What is my Best Match?"
            >
                <Badge impact="high" size="medium" text="Best Match" />
            </StyledButton>
            <BestMatchModal
                showModal={isModalOpen}
                onModalClose={() => setIsModalOpen(false)}
            />
        </>
    )
}

export default BestMatchBadge
